import ReferralsTable from '../../../referrals/ReferralsTable';
import { formatCurrency } from '@/pages/table/utils/utils';
import { useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';
import ErrorText from '../../../../components/ErrorText';
import useGetRakePayouts from '../../../../services/rake/queries/useGetRakePayouts';
import useGetRakeStats from '../../../../services/rake/queries/useGetRakeStats';
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner';
import CurrencyIcon from '@/components/CurrencySymbolMask/CurrencyIcon';
//import Button from '@/components/new-design/Button';
//import { useNavigate } from 'react-router-dom';
//import ROUTES from '@/routers/Routes';

const ReferralsPanel = () => {
  const isAgentOrAmbassador = useSelector((state: ReducerState) => !!state.auth.isAgent || !!state.auth.isAmbassador);
  const { data: rakeReferralsPayouts, error: rakePayoutError, isLoading: isRakePayoutsLoading } = useGetRakePayouts();
  const { data: rakeStats, refetch: refetchRakeStats } = useGetRakeStats();

  // const navigate = useNavigate();
  if (isAgentOrAmbassador) refetchRakeStats();

  // const navigateToAgentDashboard = () => navigate(ROUTES.AGENT_DASHBOARD);

  return (
    <div className="flex max-h-[min(728px,calc(100vh-50px))] min-h-[min(728px,calc(100vh-50px))] min-w-[min(950px,calc(100vw-50px))] max-w-[min(950px,calc(100vw-50px))] flex-col gap-4">
      <div className="flex h-full w-full justify-between rounded-[10px] bg-phenom-background-gradient-purple-fade px-4 py-2">
        <div className="flex flex-col gap-1">
          <span className="font-bold">Extensive Agent Dashboard</span>
          <span className="font-semibold text-ph-white-50">Referrals, rakeback and other metrics</span>
        </div>
        {/*<Button onClick={navigateToAgentDashboard}>Open Agent Dashboard</Button>*/}
      </div>
      {isAgentOrAmbassador && (
        <div className="mb-6 flex items-center gap-2 bg-radial-purple">
          <div className="w-full rounded-3xl bg-phenom-background-gradient-gray-violet-dark p-[1px]">
            <div className="flex h-22 w-full flex-col items-center justify-center gap-2 rounded-3xl bg-pn-violet-dark align-middle">
              <span className="text-xs font-medium text-ph-gray-evening">Rake Earned Last Week</span>
              {rakeStats && (
                <span className="flex flex-row items-center">
                  <CurrencyIcon />
                  {formatCurrency(rakeStats.data.rakePaidWeek)}
                </span>
              )}
            </div>
          </div>

          <div className="w-full rounded-3xl bg-phenom-background-gradient-gray-violet-dark p-[1px]">
            <div className="flex h-22 w-full flex-col items-center justify-center gap-2 rounded-3xl bg-pn-violet-dark align-middle">
              <span className="text-xs font-medium text-ph-gray-evening">Rake Earned Last Month</span>
              {rakeStats && (
                <span className="flex flex-row items-center">
                  <CurrencyIcon />
                  {formatCurrency(rakeStats.data.rakePaidMonth)}
                </span>
              )}
            </div>
          </div>

          <div className="w-full rounded-3xl bg-phenom-background-gradient-gray-violet-dark p-[1px]">
            <div className="flex h-22 w-full flex-col items-center justify-center gap-2 rounded-3xl bg-pn-violet-dark align-middle">
              <span className="text-xs font-medium text-ph-gray-evening">Total Rake Earned</span>
              {rakeStats && (
                <span className="flex flex-row items-center">
                  <CurrencyIcon />
                  {formatCurrency(rakeStats.data.rakePaidTotal)}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {isRakePayoutsLoading && (
        <div className="flex h-[300px] flex-col items-center justify-center">
          <LoadingSpinner size="10" />
        </div>
      )}

      {rakeReferralsPayouts && <ReferralsTable referredUsers={rakeReferralsPayouts.data} maxHeight={300} />}

      {rakeReferralsPayouts && rakeReferralsPayouts.data.length === 0 && (
        <div className="flex h-96 w-full items-center justify-center text-center">
          <p className="text-ph-gray-silver">No data to display!</p>
        </div>
      )}

      {rakePayoutError && (
        <div className="flex h-96 w-full items-center justify-center text-center">
          <ErrorText>Something went wrong fetching data. Please try again.</ErrorText>
        </div>
      )}
    </div>
  );
};

export default ReferralsPanel;
